import Vue from 'vue';
import "core-js/stable";
import "regenerator-runtime/runtime";
import 'picturefill';

// ヘッダー設定
var headerVm = new Vue({
	el: '#header',
	data: {
		activeClass: '',
		isActive: false,
		isMobile: false,
		winWidth: window.innerWidth
	},
	created: function(){
		if (
			navigator.userAgent.indexOf('iPhone') > 0 ||
			navigator.userAgent.indexOf('Android') > 0 &&
			navigator.userAgent.indexOf('Mobile') > 0
		) {              
			this.isMobile = true;          
		} else if (
			navigator.userAgent.indexOf('iPad') > 0 || 
			navigator.userAgent.indexOf('Android') > 0
		) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	},
	methods: {
		toggleMenu: function(){
			this.isActive = !this.isActive;
			this.activeClass = this.isActive ? '_isOpen' : '_isClosed' ;
		},
		handleResize: function(){
			this.winWidth = window.innerWidth;
		}
		
	},
	mounted: function(){
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy: function(){
		window.removeEventListener('resize', this.handleResize)
	}
});

// スクロール時のアニメーション 
window.onload = () => {
	startObserve()
}
function startObserve(){
	// 各要素アニメーション追加用
	const callback = (entries, observer) => {
		entries.forEach(entry => {
			let ratio = entry.intersectionRatio;
			let classlist = entry.target.classList;
			if( ratio == 0 ){
				// 完全に見えない状態
			}else if (ratio <= 0.25){
				// 領域外に出るとき
				if(classlist.contains('_jsShow')){
					classlist.remove('_jsShow');
				}
			}else if (ratio > 0.25 && ratio <= 0.75 ) {
				// 領域内に入る時
				if(!classlist.contains('_jsShow')){
					classlist.add('_jsShow');
				}
			}
		})
	}
	const option = {
		threshold: [0, 0.25, 0.75]
	};
	const observer = new IntersectionObserver( callback, option );
	const targets = document.getElementsByClassName('_jsEnter');
	for (let i = 0; i < targets.length; i++){
		observer.observe(targets[i]);
	}
	// トップからのスクロール位置計算用
	const dummyCallback = (entries, observer) => {
		entries.forEach(entry => {
			let ratio = entry.intersectionRatio;
			if(ratio == 0){
				footerVm.isHide = false;
			}else{
				footerVm.isHide = true;
			}
		})
	}
	const dummyObserver = new IntersectionObserver( dummyCallback, option );
	const dummyTarget = document.querySelector('#dummy');
	dummyObserver.observe(dummyTarget);
}


// メインコンテンツ
let mainVm = new Vue({
	el: '#main',
	data: {
		current_slide: 0,
		total_slide: 3,
		isActive: '1'
	},
	methods: {
		slide(){
			this.current_slide = this.current_slide < this.total_slide -1 ? this.current_slide +1 : 0
		},
		isSelect: function(num){
			this.isActive = num;
		}
	},
	mounted() {
	　　setInterval(() => {
			this.slide();
		}, 10000)
	}
});

// フッターコンテンツ
let footerVm = new Vue({
	el: '#footer',
	data: {
		isHide: true
	},
	methods: {
		scrollTop: function(){
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		}
	}
});